import { ArcSummaryGrid, ArcSummaryMetric } from '../components/arc/primitives/arc-primitives';

const DETAIL_METRICS = [
  { key: 'registrations', label: 'Registrace', money: false },
  { key: 'ftd_count', label: 'FTD', money: false },
  { key: 'deposits_volume', label: 'Vklady', money: true },
  { key: 'ngr_volume', label: 'NGR', money: true },
  { key: 'commission', label: 'Provize', money: true },
  { key: 'withdrawals_count', label: 'Výběry', money: false },
] as const;

export function AffilmasterDetailMetricSection({
  title,
  row,
  currency,
}: {
  title: string;
  row: object | null;
  currency: string;
}) {
  const values = row as Record<string, number> | null;
  return (
    <section className="p1-arc-scope aff-detail-metric-section" aria-label={title}>
      <h2 className="aff-detail-metric-title">{title}</h2>
      <ArcSummaryGrid className="aff-detail-metric-grid">
        {DETAIL_METRICS.map((metric) => (
          <ArcSummaryMetric
            key={metric.key}
            label={metric.label}
            value={Math.round(values?.[metric.key] ?? 0)}
            suffix={metric.money ? (currency === 'EUR' ? '\u00a0€' : '\u00a0Kč') : undefined}
            density="compact"
          />
        ))}
      </ArcSummaryGrid>
    </section>
  );
}
